import * as d3 from 'd3'

export default {
  methods: {
    draw_Table() {
      if(this.table.apply != 'Y') return

      let tbl = this.table
      let timeline = this.timeline

      this.canvasTimeline.selectAll('.TIMELINE_TABLE').remove()

      let rowHeight = tbl.lineHeight
      let tableHeight = tbl.item.length * rowHeight
      let tableWidth = timeline.length

      let tableY = 48

      let canvas = this.canvasTimeline
        .append('g')
        .attr('class', 'TIMELINE_TABLE')
        .attr('transform', `translate(0, ${tableY})`)

      canvas
        .append('rect')
        .attr('x', tbl.x)
        .attr('y', 0)
        .attr('width', tableWidth - tbl.x)
        .attr('height', tableHeight)
        .attr('fill', '#fff')

      let cutoffWeek = timeline.week.find(w => w.date === timeline.cutoff)

      if (cutoffWeek) {
        let sx = timeline.scale(cutoffWeek.sDate)
        let ex = timeline.scale(cutoffWeek.eDate)
      
        canvas.append('rect')
          .attr('x', sx)
          .attr('y', 0)
          .attr('width', ex - sx)
          .attr('height', tableHeight)
          .attr('fill', '#44A9DF')
          .attr('fill-opacity', 0.1)
          .style('pointer-events', 'none')
      }

      let line = (x1, y1, x2, y2, color) => {
        canvas
          .append('line')
          .attr('x1', x1).attr('y1', y1).attr('x2', x2).attr('y2', y2)
          .attr('stroke', color).attr('stroke-width', 0.5)
      }

      if (tbl.item.findIndex(item => item.code === 'ACT_WK') !== -1) {
        canvas
          .append('rect')
          .attr('x', 0).attr('y', tbl.item.findIndex(item => item.code === 'ACT_WK') * rowHeight)
          .attr('width', tableWidth).attr('height', rowHeight).attr('fill', '#E2EFDA')
      }

      tbl.item.forEach((item, rowIndex) => {
        let y = rowIndex * rowHeight

        let labelX =
          tbl.itemAlign === 'middle' ? tbl.x / 2 :
          tbl.itemAlign === 'end' ? -5 :
          tbl.x + 5

        canvas
          .append('rect')
          .attr('x', tbl.x).attr('y', y)
          .attr('width', -tbl.x).attr('height', rowHeight).attr('fill', '#F4F5F5').attr('opacity', 0.5)

        canvas  
          .append('text')
          .attr('x', labelX).attr('y', y + rowHeight / 2 + tbl.tSize * 0.36)
          .attr('font-size', tbl.tSize).attr('fill', item.tColor).attr('text-anchor', tbl.itemAlign)
          .text(item.name)

        line(tbl.x, y, tableWidth, y, rowIndex === 0 ? tbl.stroke.strong : tbl.stroke.medium)
      })

      timeline.week.forEach(w => {
        let sx = timeline.scale(w.sDate)
        let ex = timeline.scale(w.eDate)
        let mx = (sx + ex) / 2

        let weekData = this.skyline.data.filter(d => d.EXCEPT !== 'Y' && d.cDate == w.eDate)

        let total = d3.sum(weekData, d => d.A_TOT)
        let completed = d3.sum(weekData, d => d.A_ACT)

        tbl.item.forEach((item, rowIndex) => {
          let value = ''

          if (item.code === 'ACT_WK') {
            let weeklyData = (this.tableData || []).find(d => d.CDATE === w.date)
          
            let field = this.current.area && this.current.area !== 'OVERALL'
              ? `${this.current.area}_ACT_WK`
              : 'ACT_WK'

            if (weeklyData && weeklyData[field] != null) {
              value = d3.format(',')(weeklyData[field])
            }

          } else if (weekData.length > 0) {
            if (item.code === 'A_PRO') {
              value = total > 0 ? `${(completed / total * 100).toFixed(1)}%` : ''
            } else {
              let hasValue = weekData.some(d => d[item.code] != null)
            
              if (hasValue) {
                value = d3.format(',')(d3.sum(weekData, d => d[item.code]))
              }
            }
          }

          canvas
            .append('text')
            .attr('x', mx).attr('y',rowIndex * rowHeight + rowHeight / 2 + tbl.tSize * 0.36)
            .attr('font-size', tbl.tSize).attr('fill', item.tColor).attr('text-anchor', 'middle')
            .text(value === '' || Number(String(value).replace(/[,%]/g, '')) === 0 ? '' : value)
            .call(this.call_Table, item, weekData, w.date)
        })

        line(sx, 0, sx, tableHeight, tbl.stroke.medium)
      })

      line(tbl.x, 0, tbl.x, tableHeight, tbl.stroke.strong)
      line(0, 0, 0, tableHeight, tbl.stroke.strong)
      line(tableWidth, 0, tableWidth, tableHeight, tbl.stroke.strong)
      line(tbl.x, tableHeight, tableWidth, tableHeight, tbl.stroke.strong)
    },
  },
}